import * as React from "react";
import { User } from "../../../userTypes";
import { Button, Grid, Tooltip } from "@material-ui/core";

type Props = {
  user: User;
  onUserChanged: (user: User) => void;
  onClick: (params?: any) => any;
  disabled: boolean;
  fetchingData: boolean;
};

export default class RiskAssessmentCreateButton extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.onUserChanged(props.user);
  }

  componentWillReceiveProps(newProps: Props) {
    if (newProps.user !== this.props.user) {
      newProps.onUserChanged(newProps.user);
    }
  }

  render() {
    return (
      <Grid
        container
        spacing={16}
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item>
          {this.props.disabled === false &&
          this.props.fetchingData === false ? (
            <Button
              color="primary"
              variant="contained"
              onClick={this.props.onClick}
              disabled={this.props.disabled}
              style={{
                marginLeft: "20px",
              }}
            >
              Create risk assessment
            </Button>
          ) : (
            <Tooltip
              title="There is data missing for either the user's ID number, nationality or country of residence."
              placement="right"
            >
              <span>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={this.props.onClick}
                  disabled={this.props.disabled}
                  style={{
                    marginLeft: "20px",
                  }}
                >
                  Create risk assessment
                </Button>
              </span>
            </Tooltip>
          )}
        </Grid>
        <Grid item>
          <div>
            {this.props.fetchingData ? (
              <div>Waiting for response...</div>
            ) : null}
          </div>
        </Grid>
      </Grid>
    );
  }
}
